import { render } from "./FreetargetComp.vue?vue&type=template&id=153a4266"
import script from "./FreetargetComp.vue?vue&type=script&lang=js"
export * from "./FreetargetComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__